import { Outlet } from 'react-router-dom';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Container, Box, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';

// project imports
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import Header from './Header';
import Sidebar from "./Sidebar";
import navigation from 'menu-items';
import MenuList from "./Sidebar/MenuList";
// assets
import { IconChevronRight } from '@tabler/icons';
import { SnackbarProvider } from "notistack"

const MainLayout = () => {
  const theme = useTheme();

  return (
    <Box sx={{
      display: 'flex',
      // justifyContent: 'space-between',
      // flexDirection: 'column',
      // gap: 2,
      width: '100%',
      minHeight: `calc(100vh - ${theme.footer.height})`,
      background: '#978EFB'
    }}>
      <CssBaseline />
      {/* header */}
      <AppBar
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{
          bgcolor: theme.palette.background.default,
          borderBottom: `1px solid ${theme.palette.divider}`
        }}
      >
        <Header />
      </AppBar>
      {/* main content */}
      <Container component="main" theme={theme} sx={{ width: '100%', flexGrow: 1, p: { xs: 2, sm: 3 }, mt: 8 }}>
        {/* breadcrumb */}
        <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
        <Outlet />
      </Container>
    </Box>
  );
};

export default MainLayout;
